import { profile, axiosConfig } from 'api';
import { AxiosResponse } from 'axios';

import { AdminUser, NetacticaUserIsActiveResponse } from 'models/adminUser';
import { Response } from 'models/response';
import { AccountResponse } from 'models/user';

export type TravelArrangerUsersAllowed = {
  id: string;
  userId: string;
  name: string;
  lastName: string;
  favorite: boolean;
  email: string;
  phoneNumber: string;
  userGroupName?: string;
  userGroupId?: string;
  guest?: boolean;
  birthDate: string;
  country: string;
  documentNumber: string;
  gender: 'Male' | 'Female';
  passportNumber?: string;
  loyaltyId?: string;
  loyaltyNumber?: string;
  hasDomesticFlightPolicies?: boolean;
  hasDomesticHotelPolicies?: boolean;
  hasDomesticVehiclePolicies?: boolean;
  hasInternationalFlightPolicies?: boolean;
  hasInternationalHotelPolicies?: boolean;
  hasInternationalVehiclePolicies?: boolean;
};

export const fetchUser = (id: string) =>
  profile.get<Response<AdminUser>>(`/users/${id}`, axiosConfig).then((response) => response.data.data);

export const fetchUserByUsername = (username: string) =>
  profile.get<Response<AdminUser>>(`/users/getbyusername/${username}`, axiosConfig).then((response) => response.data.data);

export const fetchInvite = (id: string) =>
  profile.get<Response<AdminUser>>(`/invite/${id}`, axiosConfig).then((response) => response.data.data);

export const getAllowedTravelers = (): Promise<Response<TravelArrangerUsersAllowed[]>> =>
  profile
    .get<Response<TravelArrangerUsersAllowed[]>>('/Invite/GetAllUsersAndInvites/', axiosConfig)
    .then((response) => response.data)
    .catch((error) => error.data);

export const getAllowedTravelersByCompany = (id: string): Promise<Response<TravelArrangerUsersAllowed[]>> =>
  profile
    .get<Response<TravelArrangerUsersAllowed[]>>(`/Invite/GetAllUsersAndInvites/${id}/`, axiosConfig)
    .then((response) => response.data)
    .catch((error) => error.data);    

export const fetchAccount = (): Promise<AxiosResponse<Response<AccountResponse>>> =>
  profile.get('Users/GetMyAccount', axiosConfig);

export const changePassword = async (
  username: string,
  currentPassword: string,
  newPassword: string,
  countryId: string,
): Promise<any> => {
  try {
    const data = {
      userName: username,
      oldPassword: currentPassword,
      newPassword: newPassword,
      countryId: countryId ?? 'CO',
    };

    const response = await profile.post<Response<any>>('Users/UpdateNetacticaPassword', data, axiosConfig);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const changeUserStatus = async (
  userId: string,
  email: string,
  isActive: boolean,
  companyId: string,
): Promise<boolean> => {
  try {
    const response = await profile.put<Response<any>>(`Users/UpdateUserIsActive/${userId}`, {
      email: email,
      isActive: isActive,
      companyId: companyId,
      onboardingDone: isActive,
    });

    return response.data.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const fetchUserNetacticaByUsername = (username: string) =>
  profile.get<Response<AdminUser>>(`/users/getbyusername/${username}`, axiosConfig).then((response) => response.data.data);

export const GetNetacticaUserByProfileId = (profileId: number) =>
  profile.get<Response<NetacticaUserIsActiveResponse>>(`/users/getnetacticauserbyprofileid/${profileId}`, axiosConfig).then((response) => response.data.data);

export const ActivateUserStatusNetactica = async (
  username: string,
  companyId: string,
): Promise<boolean> => {
  try {
    const response = await profile.put<Response<any>>('Users/ActivateNetacticaUserByUsername', {
      username: username,
      companyId: companyId,
    });

    return response.data.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};